import { isLanguageSpanish } from 'helpers/language'
import type { FormState } from 'typings'

export const TestState: FormState = {
  firstName: 'Name',
  lastName: 'Last',
  dateOfBirth: new Date('10/10/1999'),
  phone: '1234567890',
  phoneType: {
    value: 'Mobile',
    label: isLanguageSpanish ? 'Móvil' : 'Mobile'
  },
  country: {
    value: 'USA',
    label: isLanguageSpanish ? 'Estados Unidos' : 'United States'
  },
  address: 'TEST',
  secondaryAddress: '123',
  city: 'LA',
  state: { value: 'CA', label: 'California' },
  zipCode: '90300',
  emailAddress: 'sample@syf.com',
  confirmEmail: 'sample@syf.com',
  requestTypeMissing: false,
  mailPreferred: true,
  creditCardChecked: true,
  creditCard: '12345',
  savingAccountChecked: true,
  savingProduct: '12345',
  otherAccountType: '',
  unsureRelationship: false,
  accessPersonalInfo: true,
  erasurePersonalInfo: true,
  additionalNotes: '',
  language: isLanguageSpanish ? 'spanish' : 'english',
  hardOfHearing: false,
  submissionError: '',
  showMaskedValue: false,
  isSubmitted: false,
  fromStateWhitelist: {
    label: isLanguageSpanish ? 'Sí' : 'Yes',
    value: 'Yes'
  },
  rightToRectification: false,
  rightToOptOutOfSharing: false,
  rightToOptOutOfUseOfSensitivePII: false,
  rightToTransparencyForProfiling: false,
  rectification: [],
  relationshipSynchrony: {
    label: isLanguageSpanish ? 'Sí' : 'Yes',
    value: 'Yes'
  },
  installmentAccountChecked: false,
  installmentAccount: '',
  primaryAccountPayable: { label: '', value: '' },
  businessCommercialAccount: '',
  businessCommercialAccountChecked: false,
  employee: { label: 'No', value: 'No' },
  transactionId: '',
  rightToRevokeConsent: false,
  rightToAppeal: false,
  errors: {
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    phone: '',
    phoneType: '',
    address: '',
    secondaryAddress: '',
    city: '',
    state: '',
    zipCode: '',
    emailAddress: '',
    confirmEmail: '',
    additionalNotes: '',
    recaptchaToken: '',
    creditCard: '',
    savingProduct: '',
    otherAccountType: '',
    fromStateWhitelist: '',
    // new props
    rectification: '',
    relationshipSynchrony: '',
    installmentAccount: '',
    businessCommercialAccount: '',
    employee: '',
    unsureRelationship: '',
    rightToRevokeConsent: '',
    rightToAppeal: ''
  }
}

export const InitialState: FormState = {
  firstName: '',
  lastName: '',
  dateOfBirth: null,
  phone: '',
  phoneType: { value: '', label: '' },
  country: {
    value: 'USA',
    label: isLanguageSpanish ? 'Estados Unidos' : 'United States'
  },
  address: '',
  secondaryAddress: '',
  city: '',
  state: { value: '', label: '' },
  zipCode: '',
  emailAddress: '',
  confirmEmail: '',
  requestTypeMissing: false,
  mailPreferred: true,
  creditCardChecked: false,
  creditCard: '',
  savingAccountChecked: false,
  savingProduct: '',
  otherAccountType: '',
  unsureRelationship: false,
  accessPersonalInfo: false,
  erasurePersonalInfo: false,
  additionalNotes: '',
  language: isLanguageSpanish ? 'Spanish' : 'English',
  hardOfHearing: false,
  submissionError: '',
  showMaskedValue: false,
  isSubmitted: false,
  fromStateWhitelist: { label: '', value: '' },
  rightToRectification: false,
  rightToOptOutOfSharing: false,
  rightToOptOutOfUseOfSensitivePII: false,
  rightToTransparencyForProfiling: false,
  rectification: [],
  relationshipSynchrony: { label: '', value: '' },
  installmentAccountChecked: false,
  installmentAccount: '',
  primaryAccountPayable: { label: '', value: '' },
  businessCommercialAccount: '',
  businessCommercialAccountChecked: false,
  employee: { label: '', value: '' },
  transactionId: '',
  rightToRevokeConsent: false,
  rightToAppeal: false,
  errors: {
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    phone: '',
    phoneType: '',
    address: '',
    secondaryAddress: '',
    city: '',
    state: '',
    zipCode: '',
    emailAddress: '',
    confirmEmail: '',
    additionalNotes: '',
    recaptchaToken: '',
    creditCard: '',
    savingProduct: '',
    otherAccountType: '',
    fromStateWhitelist: '',
    rectification: '',
    relationshipSynchrony: '',
    installmentAccount: '',
    businessCommercialAccount: '',
    employee: '',
    unsureRelationship: '',
    rightToRevokeConsent: '',
    rightToAppeal: ''
  }
}

const exportedObject = { TestState, InitialState }

export default exportedObject
